export default __webpack_public_path__ + "static/pic7-c987c44d59a2e731870a945076278e9a.jpg";